<div [class]="APP_CONTAINER" websiteTheme [colorScheme]="'white'">
    <!-- TrustArc banner -->
    <div id="consent_blackbar"></div>

    <router-outlet></router-outlet>

    <ng-container websiteModalHost></ng-container>
</div>
